// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const LockSm = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10.6667 7.64444H11.6C11.8209 7.64444 12 7.83545 12 8.07111V12.9067C12 13.1423 11.8209 13.3333 11.6 13.3333H4.4C4.17909 13.3333 4 13.1423 4 12.9067V8.07111C4 7.83545 4.17909 7.64444 4.4 7.64444H5.33333M10.6667 7.64444V5.51111C10.6667 4.56296 10.1333 2.66667 8 2.66667C5.86667 2.66667 5.33333 4.56296 5.33333 5.51111V7.64444M10.6667 7.64444H5.33333" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
